import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import {
  faMinus,
  faPlus,
  faNotesMedical,
} from "@fortawesome/free-solid-svg-icons";
import IMG from "../Assets/placeholder.jpg";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EMenuActions } from "../store";
import { UserActions } from "../store/user";

export default function Cart({
  ProductId,
  image,
  ProductName,
  Price,
  Quantity,
  TotalPrice,
}) {
  let dispatch = useDispatch();
  const cartItems = useSelector((state) => state.EMenu.cartItems);
  const C_URL = useSelector((state) => state.Company.c_url);
  const t_id = useSelector((state) => state.Company.t_id);

  const [imageUrl, setImageUrl] = useState(
    `https://${C_URL}/storage/uploads/tenant/${t_id}/product/${image}`
  );
  const notes = useSelector((state) => state.User.notes);
  const [showNotes, setShowNotes] = React.useState("");

  const handleImageError = () => {
    setImageUrl(IMG);
  };
  const handleDelete = () => {
    const updatedCart = cartItems.filter(
      (item) => item.ProductId !== ProductId
    );
    const updatedDel = cartItems.filter((item) => item.ProductId === ProductId);
    dispatch(EMenuActions.setCartItems(updatedCart));
    dispatch(EMenuActions.setDeletedPrice(Number(updatedDel[0].Price)));

    //code added by jere
    //remove cart items from local storage
    const localStorageItems = JSON.parse(localStorage.getItem("cartItems"));
    const localStorageNotes = JSON.parse(localStorage.getItem("Notes"));
    if (localStorageItems) {
      const ProductIdToRemove = ProductId;
      const updatedCartItems = localStorageItems.filter(
        (item) => item.ProductId !== ProductIdToRemove
      );
      if (localStorageNotes) {
        const id = ProductId;
        const updatedNotes = { ...localStorageNotes };
        delete updatedNotes[id];
        localStorage.setItem("Notes", JSON.stringify(updatedNotes));
        dispatch(UserActions.setNotes(updatedNotes));
      }
      localStorage.setItem("cartItems", JSON.stringify(updatedCartItems));
      // console.log(updatedCartItems);
    }
    //end code
  };

  const handleDecrement = () => {
    dispatch(EMenuActions.removeFromCart({ ProductId }));
  };
  const handleIncrement = () => {
    dispatch(
      EMenuActions.addToCart({
        ProductId,
        ProductName,
        Price,
        image,
        Quantity,
        TotalPrice,
      })
    );
  };
console.log(Price)
  return (
    <div>
      <div className="relative flex w-[100%] rounded-lg justify-between gap-2 bg-dark/10 p-4 md:items-center">
        <div className="rounded overflow-hidden w-[100px] max-sm:w-[30%] object-contain object-center">
          <img
            src={imageUrl}
            alt={ProductName}
            onError={handleImageError}
            className="w-26 h-28 max-sm:w-24 max-sm:h-24"
          />
        </div>
        <div className="w-[50%] max-sm:w-[50%] mx-2 flex flex-col gap-2">
          <h2 className="text-md line-clamp-2 font-extrabold uppercase leading-5 text-dark/80">
            {ProductName}
          </h2>
          <div className="text-lg flex md:justify-between items-center -mb-5 tracking-tighter">
            ₦{Price?.toLocaleString()}{" "}
            <span className="text-sm font-medium text-dark max-sm:ml-3">
              {" "}
              X {Quantity}
            </span>
            <p className="text-xl max-md:hidden font-extrabold text-secondary tracking-tighter">
              ₦{TotalPrice?.toLocaleString()}{" "}
            </p>
          </div>
          <p className="text-xl mt-4 md:hidden text-start font-extrabold text-secondary tracking-tighter">
            ₦{TotalPrice?.toLocaleString()}{" "}
          </p>
        </div>
        <div className="h-full max-sm:h-auto max-sm:w-[30%]">
            <div className="w-[50%] m-auto max-sm:w-[35%] flex flex-col gap-4 mb-2">
              <FontAwesomeIcon
                icon={faTrashCan}
                size="sm"
                className="text-primary hover:text-dark cursor-pointer"
                onClick={handleDelete}
              />
            </div>
          <div className="flex flex-row gap-2 items-center w-full h-[80%]">
            <FontAwesomeIcon
              onClick={handleDecrement}
              icon={faMinus}
              className="w-[25%] p-1 rounded-lg bg-primaryLight border-2 hover:border-primary text-primary hover:bg-primary hover:text-white"
            />
            <p className="w-[50%] text-center p-2">{Quantity}</p>
            <FontAwesomeIcon
              onClick={() =>
                handleIncrement(
                  ProductId,
                  image,
                  ProductName,
                  Price,
                  Quantity,
                  TotalPrice
                )
              }
              icon={faPlus}
              className="w-[25%] p-1 rounded-lg bg-primaryLight border-2 hover:border-primary text-primary hover:bg-primary hover:text-white"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
